module.exports = __webpack_public_path__ + "static/media/user-icon.b1622dd1.svg";